import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@fluentui/react-components';
import { CheckmarkCircle24Filled, Dismiss24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import { useUpdateSuccessDialogStyles } from './UpdateSuccessDialog.styles';

export interface UpdateSuccessDialogProps {
  open: boolean;
  roomChanged: boolean;
  onClose: () => void;
}

export const UpdateSuccessDialog = ({ open, roomChanged, onClose }: UpdateSuccessDialogProps) => {
  const styles = useUpdateSuccessDialogStyles();
  const { t } = useTranslation('planner');

  return (
    <Dialog
      open={open}
      modalType="modal"
      onOpenChange={(_, data) => {
        if (!data.open) {
          onClose();
        }
      }}
    >
      <DialogSurface className={styles.surface}>
        <DialogBody>
          <DialogTitle
            action={
              <BasicButton
                variant="subtle"
                size="medium"
                aria-label={t('updateSuccessDialog.close')}
                icon={<Dismiss24Regular />}
                onClick={onClose}
              />
            }
          >
            <span className={styles.titleRow}>
              <CheckmarkCircle24Filled className={styles.successIcon} />
              {t('updateSuccessDialog.title')}
            </span>
          </DialogTitle>
          <DialogContent>
            <p className={styles.bodyText}>
              {t(
                roomChanged
                  ? 'updateSuccessDialog.roomChangedBody'
                  : 'updateSuccessDialog.body'
              )}
            </p>
          </DialogContent>
          <DialogActions>
            <BasicButton
              variant="primary"
              size="medium"
              onClick={onClose}
              data-testid="update-success-close-button"
            >
              {t('updateSuccessDialog.closeButton')}
            </BasicButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

UpdateSuccessDialog.displayName = 'UpdateSuccessDialog';
